import React from 'react';

// Loading skeleton (handoff_app_design/README.md §4.9) — surface-2 blocks in the shape of the
// content that's loading. No spinners for page loads, no fake numbers.
//
//   <Skeleton className="h-6 w-24" />
//   <Skeleton rounded="card" className="h-40" />
export default function Skeleton({ rounded = 'md', className = '' }) {
  const radius = rounded === 'card' ? 'rounded-card' : rounded === 'control' ? 'rounded-control' : rounded === 'full' ? 'rounded-full' : 'rounded-md';
  return <div className={`bg-surface-2 animate-pulse ${radius} ${className}`} />;
}

// A stack of rows, for list-shaped loading states (e.g. a list group still fetching).
export function SkeletonRows({ count = 3, rowClassName = 'h-14' }) {
  return (
    <div className="rounded-card bg-surface border border-border overflow-hidden">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className={`px-4 py-[15px] border-b border-divider last:border-b-0 ${rowClassName}`}>
          <Skeleton className="h-full w-full" />
        </div>
      ))}
    </div>
  );
}
